var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-24X24/Search/Dark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49663677,15.3422215 C6.2764148,15.3422215 3.66591928,12.7288139 3.66591928,9.50499959 C3.66591928,6.28118532 6.2764148,3.66777769 9.49663677,3.66777769 C12.7168587,3.66777769 15.3273543,6.28118532 15.3273543,9.50499959 C15.3273543,12.7288139 12.7168587,15.3422215 9.49663677,15.3422215 M21.7578027,20.567369 L15.3565078,14.1781127 C16.3785493,12.8955916 16.9932735,11.2736778 16.9932735,9.50499959 C16.9932735,5.35973815 13.6372791,2 9.49663677,2 C5.35599439,2 2,5.35973815 2,9.50499959 C2,13.6494271 5.35599439,17.0099992 9.49663677,17.0099992 C11.2625112,17.0099992 12.8826177,16.3945892 14.1645426,15.3714076 L20.5633386,21.7581623 C20.8898587,22.082545 21.420454,22.0808772 21.751139,21.7514912 C22.0801581,21.4229389 22.0834899,20.8925856 21.7578027,20.567369",
    id: "Fill-1",
    fill: "#111E3F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.7d963b99.svg";
export { ForwardRef as ReactComponent };